<template>
  <article>
    <div class="filter">
      <div class="filter__item">
        <taskSelect v-model="filters.etid" :lists.sync="taskLists"/>
      </div>
      <div class="filter__item">
        <div class="filter__name">订单ID：</div>
        <el-input v-model="filters.orderid" placeholder="" size="mini" class="filter__input"></el-input>
      </div>
      <div class="filter__item">
        <div class="filter__name">列表ID：</div>
        <el-input v-model="filters.eoids" placeholder="多个ID用,分割" size="mini" class="filter__input"></el-input>
      </div>
      <div class="filter__item">
        <div class="filter__name">时间：</div>
        <el-date-picker
            v-model="filters.dateTime"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions" size='small'>
          </el-date-picker>
      </div>
      <button class="blue-small-btn mr-10" @click="getList">搜索</button>
      <button class="blue-small-btn" @click="moreDisplay = !moreDisplay">更多</button>
      <div class="ml-auto">
        <router-link class="blue-small-btn mr-10" :to="{path: '/earnOrderEdit', query: {eoid: 0}}">新建</router-link>
      </div>
    </div>
    <div class="filter mt-10">
      <div class="filter__item">
        <div class="filter__name">用户ID：</div>
        <el-input v-model="filters.euid" placeholder="" size="mini" class="filter__input"></el-input>
      </div>
      <div class="filter__item">
        <div class="filter__name">跟单人：</div>
        <el-select class="filter__input" size="medium" v-model="filters.opids"  multiple collapse-tags>
          <el-option :label="item.nickname" :value="item.opid" v-for="(item, index) in operLists.slice(1)" :key="index"></el-option>
        </el-select>
      </div>
      <div class="filter__item">
        <div class="filter__name">广告：</div>
        <adSelect v-model="filters.adid" :lists.sync="adLists"/>
      </div>
      <div class="filter__item">
        <div class="filter__name">口令墙：</div>
        <watchSelect v-model="filters.awid" :lists.sync="watchwordLists"/>
      </div>
      <div class="filter__item">
        <div class="filter__name">备注：</div>
        <el-input v-model="filters.remark" placeholder="" size="mini" class="filter__input"></el-input>
      </div>
      <div class="filter__item">
        <div class="filter__name">付款金额：</div>
        <input class="payment_range" type="text" v-model="filters.min_payment"/>
        <div>-</div>
        <input class="payment_range" type="text" v-model="filters.max_payment"/>
      </div>
    </div>
    <div class="flex jcs mt-20" v-if="moreDisplay">
      <button class="blue-small-btn" @click="download(1)">导出订单表格</button>
      <button class="blue-small-btn ml-10" @click="download(2)">导出报单截图</button>
      <button class="blue-small-btn ml-10" @click="download(3)">导出完成截图</button>
      <button class="blue-small-btn ml-10" @click="download(4)">导出对账订单表格</button>
      <div class="filter__item ml-30">
        <div class="filter__name">AI审核状态：</div>
        <aiReviewSelect v-model="filters.ai_review_status" :need-filter="true" />
      </div>
    </div>
    <div class="flex jcb mt-20">
      <div class="">
        <el-button size="mini" @click="toggleSelection(lists)">全选</el-button>
        <el-button size="mini" @click="toggleSelection()">取消选择</el-button>
        <el-button type="primary" plain size="mini" @click="editMultiReviseOrder">批量修改</el-button>
      </div>
      <div>
        <button class="ml-10" :class="{'blue-small-btn': item.status, 'white-small-btn': !item.status}" v-for="(item, index) in statusList" :key="index" @click="changeStatus(index)">{{item.name}}</button>
      </div>
    </div>
    <div class="flex jce mt-20" v-if="filters.status == 4 ">
      <button class="ml-10" :class="{'blue-small-btn': item.status, 'white-small-btn': !item.status}" v-for="(item, index) in invoiceStatusList" :key="index" @click="changeInvoiceStatus(index)">{{item.name}}</button>
    </div>
    <div class="flex jce mt-20" v-if="filters.status == 0 || filters.status == 1 || filters.status == 2 || filters.status == 3 || filters.status == 4 ||filters.status == 7">
      <button class="ml-10" :class="{'blue-small-btn': item.status, 'white-small-btn': !item.status}" v-for="(item, index) in handleList" :key="index" @click="changeHandle(index)">{{item.name}}</button>
      <button class="blue-small-btn ml-10" @click="earnOrderUpdate">提交</button>
    </div>

    <el-table
      ref="dataTable"
      :data="lists"
      highlight-current-row
      v-loading="listLoading"
      style="width: 100%;"
      class="mt-30"
      height="600"
      :summary-method="getSummaries"
      show-summary
      @selection-change="handleSelectionChange"
    >
      <!-- 固定列：选择框 -->
      <el-table-column type="selection" width="30" align="center" />

      <!-- 统一循环列 -->
      <el-table-column
        v-for="(col, index) in tableColumns"
        :key="`${col.columnName}-${index}`"
        :prop="col.columnName"
        :label="col.columnTitle"
        align="center"
        :width="col.width"
        v-if="col.isShow"
      >
        <!-- 表头双击打开设置 -->
        <template slot="header" slot-scope="scope">
          <span @dblclick="isShowColumn = true">
            <i
              v-if="index === 0"
              class="el-icon-setting"
              style="cursor:pointer;margin-right:6px"
              @click="isShowColumn = true"
            ></i>
            {{ col.columnTitle }}
          </span>
        </template>

        <!-- 内容：所有自定义逻辑 -->
        <template slot-scope="scope">
          <!-- ID 跳转 -->
          <router-link
            v-if="col.columnName === 'eoid'"
            :to="{path: '/earnOrderEdit', query: {eoid: scope.row.eoid}}"
            target="_blank"
          >
            {{ scope.row.eoid }}
          </router-link>

          <!-- 跟单人 -->
          <div v-else-if="col.columnName === 'oper_nickname'">
            {{ scope.row.oper_nickname }}
          </div>

          <!-- 广告(etid) -->
          <div v-else-if="col.columnName === 'etid'" @dblclick="setFiltersValue('etid', scope.row.etid)">
            {{ scope.row.title }}({{ scope.row.etid }})
          </div>

          <!-- 用户 -->
          <div v-else-if="col.columnName === 'euid'" @dblclick="setFiltersValue('euid', scope.row.euid)">
            {{ scope.row.username }}({{ scope.row.euid }})
          </div>

          <!-- 广告(adid) -->
          <div v-else-if="col.columnName === 'adid'" @dblclick="setFiltersValue('adid', scope.row.adid)">
            <div v-if="scope.row.adid !== 0">
              {{ scope.row.ad_title }}({{ scope.row.adid }})
            </div>
          </div>

          <!-- 金额 -->
          <div v-else-if="col.columnName === 'payment'" @click="editOrder(scope.$index)">
            {{ scope.row.payment }}
            <i class="el-icon-edit"></i>
          </div>

          <!-- 底价折扣、项目折扣 -->
          <div v-else-if="['min_discount', 'discount'].includes(col.columnName)">
            <span>{{scope.row[col.columnName]}}%</span>
          </div>

          <div v-else-if="['payment_img', 'finish_img', 'mosaic_payment', 'mosaic_finish', 'invoice_img'].includes(col.columnName)">
            <div v-if="scope.row[col.columnName]" @click="previewURL(scope.row.eoid,
              col.columnName === 'payment_img' ? 0 :
              col.columnName === 'finish_img' ? 2 :
              col.columnName === 'mosaic_payment' ? 3 : 
              col.columnName === 'mosaic_finish' ? 4 : 5
            )">
              <img :src="scope.row[col.columnName]" style="width:40px;height:50px" />
            </div>
          </div>

          <!-- 额外信息 -->
          <div v-else-if="col.columnName === 'extra'">
            <div v-if="scope.row.extra.length <= 25">{{ scope.row.extra }}</div>
            <el-popover v-else placement="top-end" width="200" trigger="hover" :content="scope.row.extra">
              <div slot="reference">{{ scope.row.extra.slice(0, 20) + '...' }}</div>
            </el-popover>
          </div>

          <!-- 备注 -->
          <div v-else-if="col.columnName === 'remark'">
            <span
              v-if="scope.row.remark"
              class="underline fc-blue pointer"
              @click="editOrder(scope.$index)"
            >
              {{ scope.row.remark }}
            </span>
            <i v-else class="el-icon-edit" @click="editOrder(scope.$index)"></i>
          </div>

          <!-- 状态 -->
          <div v-else-if="col.columnName === 'status'">
            <div v-if="scope.row.status == 7">预售</div>
            <div v-if="scope.row.status == 6">拒绝</div>
            <div v-if="scope.row.status == 5">失效</div>
            <div v-if="scope.row.status == 4">已提现</div>
            <div v-if="scope.row.status == 3">返款中</div>
            <div v-if="scope.row.status == 2">完成订单</div>
            <div v-if="scope.row.status == 1">跟单中</div>
            <div v-if="scope.row.status == 0">报单</div>
          </div>

          <div v-else-if="col.columnName === 'purchase'">
            <div v-if="scope.row.purchase == 0">需要返现</div>
            <div v-if="scope.row.purchase == 1">直接折扣</div>
            <div v-if="scope.row.purchase == 2">假单</div>
            <div v-if="scope.row.purchase == 3">囤货</div>
            <div v-if="scope.row.purchase == 4">固返</div>
          </div>

          <!-- AI报单图审核 -->
          <div v-else-if="col.columnName === 'ai_review_upload'">
            <div v-if="scope.row.ai_review_upload == 0">未审核</div>
            <div v-if="scope.row.ai_review_upload == 1">审核通过</div>
            <div v-if="scope.row.ai_review_upload == 2">需要人工校验</div>
            <div v-if="scope.row.ai_review_upload == 3">AI识别失败</div>
          </div>

          <!-- AI完成图审核 -->
          <div v-else-if="col.columnName === 'ai_review_finish'">
            <div v-if="scope.row.ai_review_finish == 0">未审核</div>
            <div v-if="scope.row.ai_review_finish == 1">审核通过</div>
            <div v-if="scope.row.ai_review_finish == 2">需要人工校验</div>
            <div v-if="scope.row.ai_review_finish == 3">AI识别失败</div>
          </div>

          <!-- 发票 -->
          <div v-else-if="col.columnName === 'is_invoice'">
            <div v-if="scope.row.is_invoice == 0">否</div>
            <div v-if="scope.row.is_invoice == 1">是</div>
          </div>

          <!-- 状态 -->
          <div v-else-if="col.columnName === 'invoice_status'">
            <div v-if="scope.row.invoice_status == 5">拒绝</div>
            <div v-if="scope.row.invoice_status == 4">已提现</div>
            <div v-if="scope.row.invoice_status == 3">待提现</div>
            <div v-if="scope.row.invoice_status == 2">审核通过</div>
            <div v-if="scope.row.invoice_status == 1">待审核</div>
            <div v-if="scope.row.invoice_status == 0">未上传</div>
          </div>

          <!-- 创建时间 -->
          <div v-else-if="col.columnName === 'create_time'" v-html="formatTimeStamp(scope.row.create_time)"></div>

          <!-- 编辑时间 -->
          <div v-else-if="col.columnName === 'last_edit'" v-html="formatTimeStamp(scope.row.last_edit)"></div>

          <!-- 其他普通列自动显示 -->
          <span v-else>
            {{ scope.row[col.columnName] }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="100" align="center" fixed="right" v-if="filters.status === -1">
        <template slot-scope="scope">
          <el-button type="primary" plain size="mini" @click="editOrder(scope.$index)" v-if="scope.row.status !== 5 ">修改订单</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="" label="操作" width="160" fixed="right" align="center" v-if="filters.status !== -1">
        <template slot-scope="scope">
            <div v-if="filters.status == 0 || filters.status == 1 || filters.status == 2 || filters.status == 3 || filters.status == 4 && filters.invoice_status == 1 || filters.status === 7" @dblclick="handleRadioChange(scope.$index)">
                <el-radio-group v-model="scope.row.isChoose">
                  <el-radio :label="1">通过</el-radio>
                  <el-radio :label="0">拒绝</el-radio>
                </el-radio-group>
            </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination layout="total, sizes, pager, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="filters.l" :page-sizes="[20, 50, 80, 100, 200]" :total="filters.total" :current-page="filters.p" class="tac mt-36 pb-36">
    </el-pagination>
    <TableColumnSetting
      :visible.sync="isShowColumn"
      :column-list.sync="tableColumns"
      :default-columns="defaultColumns"
      :storage-key="`${$options.name}_table_columns`"
    />
    <el-dialog title="修改订单" :visible.sync="orderDialog" size="tiny" width="80%" height="80%" style="margin-top: -5% !important" center>
      <el-form ref="form" :model="orderInfo" label-width="100px">
        <div class="dataForm__item">
          <el-form-item label="ID">
            <el-input v-model="orderInfo.eoid" disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="活动名称">
            <el-select placeholder="请选择" v-model="orderInfo.etid" disabled="true">
              <el-option v-for="item in taskLists" :key="item.value" :label="item.title" :value="item.etid"> </el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="dataForm__item">
          <el-form-item label="订单号">
            <el-input v-model="orderInfo.orderid" disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="用户名">
            <el-input v-model="orderInfo.username" disabled="true">
                <template slot="prepend">({{orderInfo.euid}})</template>
            </el-input>
          </el-form-item>
          <el-form-item label="跟单人">
            <el-select v-model="orderInfo.opid" >
              <el-option v-for="item in orderOperLists" :key="item.opid" :label="item.nickname" :value="item.opid"> </el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="">
          <el-form-item label="购买类型">
            <el-radio-group v-model="orderInfo.purchase">
              <div class="dib mr-20">
                <el-radio :label="0">需要返款</el-radio>
                <el-radio :label="1">直接折扣</el-radio>
                <el-radio :label="2">假单</el-radio>
                <el-radio :label="3">囤货</el-radio>
                <el-radio :label="4">固返</el-radio>
              </div>
            </el-radio-group>
          </el-form-item>
        </div>
        <div class="dataForm__item">
          <el-form-item label="底价折扣">
            <el-input v-model="orderInfo.min_discount" disabled="true">
              <template slot="append">%</template>
            </el-input>
          </el-form-item>
          <el-form-item label="折扣">
            <el-input v-model="orderInfo.discount">
              <template slot="append">%</template>
            </el-input>
          </el-form-item>
        </div>
        <div class="dataForm__item">
          <el-form-item label="金额">
            <el-input v-model="orderInfo.payment"></el-input>
          </el-form-item>
          <el-form-item label="拍手费">
            <el-input v-model="orderInfo.agency_fees"></el-input>
          </el-form-item>
          <el-form-item label="发票奖励">
            <el-input v-model="orderInfo.bonus"></el-input>
          </el-form-item>
        </div>
        <div class="dataForm__item">
          <el-form-item label="报单截图">
            <div class="headimg-container relative" style="width:150px">
              <uploadHeadImage :url.sync="orderInfo.payment_img" :itype="5"></uploadHeadImage>
            </div>
          </el-form-item>
          <el-form-item label="完成截图">
            <div class="headimg-container relative" style="width:150px">
              <uploadHeadImage :url.sync="orderInfo.finish_img" :itype="5"></uploadHeadImage>
            </div>
          </el-form-item>
          <el-form-item label="发票截图">
            <div class="headimg-container relative" style="width:150px">
              <uploadHeadImage :url.sync="orderInfo.invoice_img" :itype="5"></uploadHeadImage>
            </div>
          </el-form-item>
        </div>
        <div class="dataForm__item">
          <el-form-item label="额外信息">
            <el-input type="textarea" :rows="2" v-model="orderInfo.extra" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="快递单号">
            <el-input type="textarea" :rows="2" v-model="orderInfo.express_id" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="备注">
            <el-input type="textarea" :rows="2" v-model="orderInfo.remark" size="mini"></el-input>
          </el-form-item>
        </div>
        <div class="dataForm__item">
          <el-form-item label="AI报单图识别">
            <aiReviewUploadSelect v-model="orderInfo.ai_review_upload" />
          </el-form-item>
          <el-form-item label="AI完成图识别">
            <aiReviewFinishSelect v-model="orderInfo.ai_review_finish" />
          </el-form-item>
        </div>
        <el-form-item label="是否开发票">
            <el-radio-group v-model="orderInfo.is_invoice">
              <div class="dib mr-20">
                <el-radio :label="0">否</el-radio>
                <el-radio :label="1">开</el-radio>
              </div>
            </el-radio-group>
        </el-form-item>
        <el-form-item label="状态">
            <el-radio-group v-model="orderInfo.status">
              <div class="dib mr-20">
                <el-radio :label="0">报单</el-radio>
                <el-radio :label="1">跟单中</el-radio>
                <el-radio :label="2">完成订单</el-radio>
                <el-radio :label="5">失效</el-radio>
                <el-radio :label="6">拒绝</el-radio>
              </div>
            </el-radio-group>
        </el-form-item>
        <div class="flex jcc mt-30">
          <div class="blue-large-btn mr-20" @click="earnOrderEdit">保存</div>
          <div class="gray-large-btn" @click="orderDialog = false">取消</div>
        </div>
      </el-form>
    </el-dialog>
    <el-dialog title="批量修改" :visible.sync="multiReviseDialog" size="tiny" width="70%" center>
      <el-form ref="form" :model="multiReviseInfo" label-width="100px">
        <el-form-item label="订单ID集合">
          <el-input v-model="multiReviseInfo.eoids" class="dataForm__input" :disabled="true">
          </el-input>
        </el-form-item>
        <el-form-item label="活动名称">
          <el-select placeholder="请选择" v-model="multiReviseInfo.etid" :disabled="true">
            <el-option v-for="item in taskLists" :key="item.value" :label="item.label" :value="item.value"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="跟单人">
          <el-select class="filter__input" size="medium" v-model="multiReviseInfo.opid" placeholder="不选不更改">
            <el-option :label="item.nickname" :value="item.opid" v-for="(item, index) in operLists.slice(1)" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <div class="dataForm__item">
          <el-form-item label="底价折扣">
            <el-input v-model="multiReviseInfo.min_discount" placeholder="不填不更改">
              <template slot="append">%</template>
            </el-input>
          </el-form-item>
          <el-form-item label="参考底价折扣" class="ml-20">
            <el-input v-model="multiReviseInfo.old_min_discount" class="dataForm__input" :disabled="true">
              <template slot="append">%</template>
            </el-input>
          </el-form-item>
        </div>
        <div class="dataForm__item">
          <el-form-item label="折扣">
            <el-input v-model="multiReviseInfo.discount" placeholder="不填不更改">
              <template slot="append">%</template>
            </el-input>
          </el-form-item>
          <el-form-item label="参考折扣" class="ml-20">
            <el-input v-model="multiReviseInfo.old_discount" class="dataForm__input" :disabled="true">
              <template slot="append">%</template>
            </el-input>
          </el-form-item>
        </div>
        <div class="dataForm__item">
          <el-form-item label="金额">
            <el-input v-model="multiReviseInfo.payment" placeholder="不填不更改">
              <template slot="append">￥</template>
            </el-input>
          </el-form-item>
          <el-form-item label="参考金额" class="ml-20">
            <el-input v-model="multiReviseInfo.old_payment" class="dataForm__input" :disabled="true">
              <template slot="append">￥</template>
            </el-input>
          </el-form-item>
        </div>
        <div class="dataForm__item">
          <el-form-item label="拍手费">
            <el-input v-model="multiReviseInfo.agency_fees" placeholder="不填不更改">
              <template slot="append">￥</template>
            </el-input>
          </el-form-item>
          <el-form-item label="参考拍手费" class="ml-20">
            <el-input v-model="multiReviseInfo.old_agency_fees" class="dataForm__input" :disabled="true">
              <template slot="append">￥</template>
            </el-input>
          </el-form-item>
        </div>
        <div class="dataForm__item">
          <el-form-item label="发票奖励">
            <el-input v-model="multiReviseInfo.bonus" placeholder="不填不更改">
              <template slot="append">￥</template>
            </el-input>
          </el-form-item>
          <el-form-item label="参考发票奖励" class="ml-20">
            <el-input v-model="multiReviseInfo.old_bonus" class="dataForm__input" :disabled="true">
              <template slot="append">￥</template>
            </el-input>
          </el-form-item>
        </div>
        <div class="dataForm__item">
          <el-form-item label="额外信息">
            <el-input type="textarea" :rows="2" class="dataForm__input" v-model="multiReviseInfo.extra" size="mini" placeholder="不填不更改"></el-input>
          </el-form-item>
          <el-form-item label="快递信息">
            <el-input type="textarea" :rows="2" class="dataForm__input" v-model="multiReviseInfo.express_id" size="mini" placeholder="不填不更改"></el-input>
          </el-form-item>
          <el-form-item label="备注">
            <el-input type="textarea" :rows="2" class="dataForm__input" v-model="multiReviseInfo.remark" size="mini" placeholder="不填不更改"></el-input>
          </el-form-item>
        </div>
        <div class="dataForm__item">
          <el-form-item label="是否开发票">
            <earnIsInvioceSelect v-model="multiReviseInfo.is_invoice" />
          </el-form-item>
          <el-form-item label="订单状态">
            <orderStatusSelect v-model="multiReviseInfo.status" />
          </el-form-item>
        </div>
        <div class="flex jcc mt-30">
          <div class="blue-large-btn mr-20" @click="earnOrderMultiRevise">保存</div>
          <div class="gray-large-btn" @click="multiReviseDialog = false">取消</div>
        </div>
      </el-form>
    </el-dialog>
  </article>
</template>

<script>
import mixinList from '../../../mixins/list'
import util from '../../../script/util'
import {taskLists, earnOrderLists, earnOrderUpdate, downloadEarnOrderLists, earnOrderEdit, operLists, earnOrderMultiRevise, earnOrderInvoiceUpdate} from '../../../api/api'
import uploadHeadImage from '../../../components/uploadImage.vue'
import adSelect from '../../../components/data-select/adSelect.vue'
import watchSelect from '../../../components/data-select/watchSelect.vue'
import taskSelect from '../../../components/data-select/taskSelect.vue'
import aiReviewSelect from '../../../components/data-select/aiReviewSelect'
import aiReviewUploadSelect from '../../../components/data-select/aiReviewUploadSelect'
import aiReviewFinishSelect from '../../../components/data-select/aiReviewFinishSelect'
import earnIsInvioceSelect from '../../../components/data-select/earnIsInvioceSelect'
import orderStatusSelect from '../../../components/data-select/orderStatusSelect'

export default {
  name: 'earnOrder',
  mixins: [mixinList],
  components: {
    uploadHeadImage,
    adSelect,
    watchSelect,
    taskSelect,
    aiReviewSelect,
    aiReviewUploadSelect,
    aiReviewFinishSelect,
    earnIsInvioceSelect,
    orderStatusSelect
  },
  data () {
    return {
      multipleSelection: [],
      opid: '',
      lists: [],
      listLoading: false,
      filters: {
        p: 1,
        l: 20,
        total: 0,
        dateTime: '',
        start_time: '',
        end_time: '',
        status: -1,
        etid: '',
        eoids: '',
        orderid: '',
        euid: '',
        opids: [],
        adid: '',
        awid: '',
        min_payment: '',
        max_payment: '',
        remark: '',
        download: '',
        ai_review_status: '',
        invoice_status: -1
      },
      taskLists: [],
      operLists: [],
      orderOperLists: [],
      adLists: [],
      watchwordLists: [],
      isShowColumn: false,
      defaultColumns: [
        { columnName: 'eoid', columnTitle: 'ID', width: 60, isShow: true, isSum: false },
        { columnName: 'oper_nickname', columnTitle: '跟单人', width: 100, isShow: true, isSum: false },
        { columnName: 'etid', columnTitle: '任务', width: '120', isShow: true, isSum: false },
        { columnName: 'euid', columnTitle: '用户', width: 100, isShow: true, isSum: false },
        { columnName: 'adid', columnTitle: '广告', width: 100, isShow: true, isSum: false },
        { columnName: 'orderid', columnTitle: '订单ID', width: 150, isShow: true, isSum: false },
        { columnName: 'nickname', columnTitle: '微信昵称', width: '', isShow: true, isSum: false },
        { columnName: 'payment', columnTitle: '金额', width: '', isShow: true, isSum: true },
        { columnName: 'min_discount', columnTitle: '底价折扣', width: '', isShow: true, isSum: false },
        { columnName: 'discount', columnTitle: '项目折扣', width: '', isShow: true, isSum: false },
        { columnName: 'commission', columnTitle: '佣金', width: '', isShow: true, isSum: true },
        { columnName: 'agency_fees', columnTitle: '拍手费', width: '', isShow: true, isSum: true },
        { columnName: 'bonus', columnTitle: '发票奖励', width: '', isShow: true, isSum: true },
        { columnName: 'payment_img', columnTitle: '报单截图', width: '', isShow: true, isSum: false },
        { columnName: 'finish_img', columnTitle: '完成截图', width: '', isShow: true, isSum: false },
        { columnName: 'extra', columnTitle: '额外信息', width: 100, isShow: true, isSum: false },
        { columnName: 'express_id', columnTitle: '快递单号', width: '', isShow: true, isSum: false },
        { columnName: 'remark', columnTitle: '备注', width: '', isShow: true, isSum: false },
        { columnName: 'status', columnTitle: '状态', width: '', isShow: true, isSum: false },
        { columnName: 'purchase', columnTitle: '购买类型', isShow: true, isSum: false },
        { columnName: 'ai_review_upload', columnTitle: 'AI报单图审核', width: '', isShow: true, isSum: false },
        { columnName: 'ai_review_finish', columnTitle: 'AI完成图审核', width: '', isShow: true, isSum: false },
        { columnName: 'is_invoice', columnTitle: '开启发票', width: '', isShow: true, isSum: false },
        { columnName: 'invoice_img', columnTitle: '发票截图', width: '', isShow: true, isSum: false },
        { columnName: 'invoice_status', columnTitle: '发票状态', width: '', isShow: true, isSum: false },
        { columnName: 'mosaic_payment', columnTitle: '马赛克报单图', width: '', isShow: true, isSum: false },
        { columnName: 'mosaic_finish', columnTitle: '马赛克完成图', width: '', isShow: true, isSum: false },
        { columnName: 'sale_discount', columnTitle: '出货折扣', width: '', isShow: true, isSum: false },
        { columnName: 'create_time', columnTitle: '创建时间', width: 100, isShow: true, isSum: false },
        { columnName: 'last_edit', columnTitle: '编辑时间', width: 100, isShow: true, isSum: false },
        { columnName: 'exchange_time', columnTitle: '兑换时间', width: 100, isShow: true, isSum: false },
        { columnName: 'invoice_time', columnTitle: '发票奖励时间', width: 100, isShow: true, isSum: false }
      ],
      tableColumns: [],
      // 状态按钮
      statusList: [
        {
          name: '所有',
          value: -1,
          status: 1
        },
        {
          name: '报单',
          value: 0,
          status: 0
        },
        {
          name: '跟单中',
          value: 1,
          status: 0
        },
        {
          name: '完成订单',
          value: 2,
          status: 0
        },
        {
          name: '提现中',
          value: 3,
          status: 0
        },
        {
          name: '已提现',
          value: 4,
          status: 0
        },
        {
          name: '失效',
          value: 5,
          status: 0
        },
        {
          name: '拒绝',
          value: 6,
          status: 0
        }
      ],
      // 操作按钮
      handleList: [
        {
          name: '全部通过',
          value: 1,
          status: 0
        },
        {
          name: '全部拒绝',
          value: 2,
          status: 0
        }
      ],
      // 发票状态按钮
      invoiceStatusList: [
        {
          name: '发票',
          value: -1,
          status: 1
        },
        {
          name: '未上传',
          value: 0,
          status: 0
        },
        {
          name: '待审核',
          value: 1,
          status: 0
        },
        {
          name: '审核通过',
          value: 2,
          status: 0
        },
        {
          name: '待打款',
          value: 3,
          status: 0
        },
        {
          name: '已打款',
          value: 4,
          status: 0
        },
        {
          name: '拒绝',
          value: 5,
          status: 0
        },
      ],
      pickerOptions: {
        shortcuts: []
      },
      previewDialog: false, // 查看图片弹窗
      previewList: [], // 查看列表
      moreDisplay: false,
      orderDialog: false,
      orderInfo: {
        eoid: '',
        orderid: '',
        nickname: '',
        etid: '',
        opid: '',
        title: '',
        euid: '',
        username: '',
        purchase: 3,
        min_discount: '',
        discount: '',
        payment: '',
        agency_fees: '',
        commission: '',
        bonus: '',
        payment_img: '',
        finish_img: '',
        ai_review_upload: '',
        ai_review_finish: '',
        extra: '',
        express_id: '',
        remark: '',
        is_invoice: '',
        status: ''
      },
      multiReviseDialog: false,
      multiReviseInfo: {
        eoids: '',
        etid: '',
        opid: '',
        old_min_discount: '',
        old_payment: '',
        old_discount: '',
        old_agency_fees: '',
        old_bonus: '',
        min_discount: '',
        payment: '',
        discount: '',
        agency_fees: '',
        bonus: '',
        extra: '',
        express_id: '',
        remark: '',
        is_invoice: '',
        status: ''
      }
    }
  },
  methods: {
    toggleSelection (rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.dataTable.toggleRowSelection(row)
        })
      } else {
        this.$refs.dataTable.clearSelection()
      }
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    getSelectionValue (key) {
      let lists = []

      this.multipleSelection.forEach(item => {
        lists.push(item[key])
      })

      return lists.join('|')
    },
    handleSizeChange (val) {
      this.filters.l = val
      this.getList()
    },
    handleCurrentChange (val) {
      this.filters.p = val
      this.getList()
    },
    handleRadioChange (index) {
      this.lists[index].isChoose = ''
    },
    changeHandle (index) {
      this.handleList.forEach(item => {
        item.status = 0
      })
      this.handleList[index].status = 1
      switch (this.handleList[index].value) {
        case 1: // 全部通过
          this.lists.forEach((item) => {
            item.isChoose = 1
            item.isCheck = false
          })
          break
        case 2: // 全部拒绝
          this.lists.forEach((item) => {
            item.isChoose = 0
            item.isCheck = false
          })
          break
      }
    },
    // 格式化时间
    formatTimeStamp (time) {
      return util.formatTimeStamp(time)
    },
    dateTimeChange () {
      this.filters.start_time = parseInt(new Date(this.filters.dateTime[0]).getTime() / 1000)
      this.filters.end_time = parseInt(new Date(this.filters.dateTime[1]).getTime() / 1000)
    },
    previewURL (eoid, status) {
      let images = []
      let initialViewIndex = 0
      this.lists.forEach((item) => {
        if (status === 0) {
          if (item.payment_img !== '') {
            images.push(item.payment_img)
          }
        } else if (status === 2) {
          if (item.finish_img !== '') {
            images.push(item.finish_img)
          }
        } else if (status === 3) {
          if (item.mosaic_payment !== '') {
            images.push(item.mosaic_payment)
          }
        } else if (status === 4) {
          if (item.mosaic_finish !== '') {
            images.push(item.mosaic_finish)
          }
        } else if (status === 5) {
          if (item.invoice_img !== '') {
            images.push(item.invoice_img)
          }
        } else {
          if (item.presale_img !== '') {
            images.push(item.presale_img)
          }
        }

        if (item.eoid === eoid) {
          initialViewIndex = images.length - 1
        }
      })

      this.$viewerApi({
        options: {
          toolbar: true,
          initialViewIndex: initialViewIndex
        },
        images: images
      })
    },
    getSummaries (param) {
      return util.getSummaries(param, this.defaultColumns, 1)
    },
    changeStatus (index) {
      this.statusList.forEach(item => {
        item.status = 0
      })
      this.statusList[index].status = 1
      this.filters.status = this.statusList[index].value
      this.filters.p = 1
      this.handleList.forEach(item => {
        item.status = 0
      })
      this.getList()
    },
    changeInvoiceStatus (index) {
      this.invoiceStatusList.forEach(item => {
        item.status = 0
      })
      this.invoiceStatusList[index].status = 1
      this.filters.invoice_status = this.invoiceStatusList[index].value
      this.filters.p = 1
      this.handleList.forEach(item => {
        item.status = 0
      })
      this.getList()
    },
    getMonthList () {
      let date = new Date()
      let year = date.getFullYear()
      let month = date.getMonth() + 1

      for (let i = 0; i < 12; i++) {
        let monthStr = (month > 9) ? month.toString() : ('0' + month)
        let yearMonth = year.toString() + '-' + monthStr

        let nextMonth = new Date(year, month, 1, 0, 0, 0)
        nextMonth = nextMonth.setDate(nextMonth.getDate() - 1)

        if (month === 1) {
          year = year - 1
          month = 12
        } else {
          month = month - 1
        }

        let currentMonth = new Date(year, month, 1, 0, 0, 0)

        this.pickerOptions['shortcuts'].push({
          text: yearMonth,
          onClick (picker) {
            const end = new Date(nextMonth)
            const start = new Date(currentMonth)
            picker.$emit('pick', [start, end])
          }
        })
      }
    },
    getTaskLists () {
      let params = {
        market: 3,
        l: 1000,
        p: 1
      }
      taskLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.taskLists = data.d.lists.map((item, index) => {
            return {
              title: item.title + '(' + item.etid + ')',
              etid: item.etid
            }
          })
          this.taskLists.unshift({
            title: '所有',
            etid: ''
          })
        }
      })
    },
    getOperLists () {
      let params = {
        market: 3,
        status: 1,
        l: 500,
        p: 1
      }
      operLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.operLists = data.d.lists.map((item, index) => {
            return {
              nickname: item.nickname,
              opid: item.opid
            }
          })
          this.orderOperLists = this.operLists.slice()
          this.operLists.unshift({
            nickname: '所有',
            opid: ''
          })
        }
      })
    },
    getList () {
      let filters = this.filters
      let params = {
        p: filters.p,
        l: filters.l
      }
      if (filters.status !== -1) {
        params.status = filters.status
      }
      if (filters.invoice_status !== -1) {
        params.invoice_status = filters.invoice_status
      }
      if (filters.etid !== '') {
        params.etid = filters.etid
      }
      if (filters.start_time !== '') {
        params.start_time = filters.start_time
      }
      if (filters.end_time !== '') {
        params.end_time = filters.end_time
      }
      if (filters.orderid !== '') {
        params.orderid = filters.orderid
      }
      if (filters.euid !== '') {
        params.euid = filters.euid
      }
      if (filters.opids.length !== 0) {
        params.opids = filters.opids.join(',')
      }
      if (filters.adid !== '') {
        params.adid = filters.adid
      }
      if (filters.awid !== '') {
        params.awid = filters.awid
      }
      if (filters.eoids !== '') {
        params.eoids = filters.eoids
      }
      if (filters.min_payment !== '') {
        params.min_payment = filters.min_payment
      }
      if (filters.max_payment !== '') {
        params.max_payment = filters.max_payment
      }
      if (filters.remark !== '') {
        params.remark = filters.remark
      }
      if (filters.ai_review_status !== '') {
        if (filters.ai_review_status < 10) {
          params.ai_review_upload = filters.ai_review_status
        } else {
          params.ai_review_finish = filters.ai_review_status - 10
        }
      }
      this.listLoading = true
      earnOrderLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          data.d.lists.forEach((item) => {
            item.isChoose = ''
            item.isCheck = false
          })
          this.checkAll = false
          this.lists = data.d.lists
          this.filters.total = data.d.total
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
        this.listLoading = false
      }).catch(() => {
        this.listLoading = false
        this.$notify({
          title: '失败',
          message: '服务器出错了',
          type: 'error'
        })
      })
    },
    setFiltersValue (key, value) {
      if (this.filters[key] === '') {
        this.filters[key] = value
      } else {
        this.filters[key] = ''
      }
      this.getList()
    },
    earnOrderUpdate () {
      let lists = this.lists
      let accept = []
      let reject = []
      lists.forEach((item) => {
        if (item.isChoose === 1) {
          accept.push(item.eoid)
        }
        if (item.isChoose === 0) {
          reject.push(item.eoid)
        }
      })

      let params = {
        accept: accept.join('|'),
        reject: reject.join('|')
      }

      let condition = true
      if (this.filters.status != 4) {
        condition = false
      }
      
      // earnOrderUpdate(params).then((res) => {
      (condition? earnOrderInvoiceUpdate: earnOrderUpdate)(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.$notify({
            title: '成功',
            message: '提交成功',
            type: 'success'
          })
          this.getList()
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
      })
    },
    download (choose) {
      let filters = this.filters
      let link = downloadEarnOrderLists + '?choose=' + choose

      if (filters.etid === '' && filters.start_time === '') {
        this.$notify({
          title: '失败',
          message: '请先选择活动、或者时间',
          type: 'error'
        })
        return
      }

      if (filters.etid !== '') {
        link = link + '&etid=' + filters.etid
      }
      if (filters.euid !== '') {
        link = link + '&euid=' + filters.euid
      }
      if (filters.opids.length !== 0) {
        link = link + '&opids=' + filters.opids.join(',')
      }
      if (filters.start_time !== '') {
        link = link + '&start_time=' + filters.start_time
      }
      if (filters.end_time !== '') {
        link = link + '&end_time=' + filters.end_time
      }
      if (filters.status !== -1) {
        link = link + '&status=' + filters.status
      }
      if (filters.orderid !== '') {
        link = link + '&orderid=' + filters.orderid
      }
      if (filters.remark !== '') {
        link = link + '&remark=' + filters.remark
      }
      if (filters.ai_review_status !== '') {
        if (filters.ai_review_status < 10) {
          link = link + '&ai_review_upload=' + filters.ai_review_status
        } else {
          let ai_review_finish = filters.ai_review_status - 10
          link = link + '&ai_review_finish=' + ai_review_finish
        }
      }
      window.open(link, 'a')
    },
    earnOrderEdit () {
      let params = this.orderInfo

      earnOrderEdit(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.$notify({
            title: '成功',
            message: '提交成功',
            type: 'success'
          })
          this.getList()
          this.orderDialog = false
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
      })
    },
    earnOrderMultiRevise () {
      let params = {
        eoids: this.multiReviseInfo.eoids,
        etid: this.multiReviseInfo.etid
      }

      for (let key of ['opid', 'min_discount', 'payment', 'discount', 'agency_fees', 'bonus', 'extra', 'express_id', 'remark', 'is_invoice', 'status']) {
        if (this.multiReviseInfo[key] !== '') {
          params[key] = this.multiReviseInfo[key]
        }
      }

      earnOrderMultiRevise(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.$notify({
            title: '成功',
            message: '提交成功',
            type: 'success'
          })
          this.getList()
          this.multiReviseDialog = false
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
      })
    },

    editMultiReviseOrder () {
      let eoids = this.getSelectionValue('eoid')

      let content = ''

      if (eoids === '') {
        content = '请选择需要上报的订单'
      }

      if (this.filters.etid === '') {
        content = '请选择需要广告'
      }

      if (content) {
        this.$notify({
          title: '失败',
          message: content,
          type: 'error'
        })
        return
      }

      this.multiReviseDialog = true

      for (let key in this.multiReviseInfo) {
        this.multiReviseInfo[key] = ''
      }

      this.multiReviseInfo['etid'] = this.filters.etid
      this.multiReviseInfo['eoids'] = eoids
      this.multiReviseInfo['old_opid'] = this.getSelectionValue('opid')
      this.multiReviseInfo['old_min_discount'] = this.getSelectionValue('min_discount')
      this.multiReviseInfo['old_discount'] = this.getSelectionValue('discount')
      this.multiReviseInfo['old_payment'] = this.getSelectionValue('payment')
      this.multiReviseInfo['old_agency_fees'] = this.getSelectionValue('agency_fees')
      this.multiReviseInfo['old_bonus'] = this.getSelectionValue('bonus')
    },
    editOrder (index) {
      this.orderDialog = true
      for (let key in this.orderInfo) {
        this.orderInfo[key] = this.lists[index][key]
      }
    }
  },
  mounted () {
    this.opid = parseInt(window.localStorage.getItem('opid'))
    this.getMonthList()
    let etid = parseInt(this.$route.query.etid || 0)
    let euid = parseInt(this.$route.query.euid || 0)
    let eoids = this.$route.query.eoids || ''
    if (etid) {
      this.filters.etid = etid
    }
    if (eoids) {
      this.filters.eoids = eoids
    }
    if (euid) {
      this.filters.euid = euid
    }
    this.getOperLists()
    this.getList()
  },
  updated () {
    this.$nextTick(() => {
      this.$refs['dataTable'].doLayout()
      this.$refs['dataTable'].bodyWrapper.scrollTop = 0
    })
  },
  watch: {
    'filters.dateTime': 'dateTimeChange',
    'filters.etid': 'getList',
    'filters.eoids': 'getList',
    'filters.orderid': 'getList',
    'filters.start_time': 'getList',
    'filters.euid': 'getList',
    'filters.opids': 'getList',
    'filters.adid': 'getList',
    'filters.awid': 'getList',
    'filters.min_payment': 'getList',
    'filters.max_payment': 'getList',
    'filters.ai_review_status': 'getList'
  }
}
</script>

<style scoped>
/deep/ .el-table .el-table__cell {
  padding: 10px 0px;
}

/* 修改单元格内容的 padding */
/deep/ .el-table .cell {
  padding: 0px 6px; /* 上下0，左右6px */
}

.payment_range {
  background-color: #FFF;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #DCDFE6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  height: 28px;
  line-height: 28px;
  outline: 0;
  padding: 0 15px;
  width: 80px;
  -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
  transition: border-color .2s cubic-bezier(.645,.045,.355,1);
}
/* 子项：自动平分剩余宽度，所有项一样宽 */
.dataForm__item .el-form-item {
  width: 400px !important; /* 固定300px，核心 */
}

.dataForm__input {
  width: 100%;
}

</style>



// WEBPACK FOOTER //
// src/page/module/earn/earnOrder.vue